import { render, staticRenderFns } from "./__composantTest3.vue?vue&type=template&id=139c91c4"
import script from "./__composantTest3.vue?vue&type=script&lang=js"
export * from "./__composantTest3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports